import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '−' : '+';
  return sign + '₹' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}
function fmtOI(v) {
  if (v == null || isNaN(v)) return '--';
  var a = Math.abs(v);
  return a >= 1e7 ? (v / 1e7).toFixed(2) + 'Cr' : a >= 1e5 ? (v / 1e5).toFixed(1) + 'L' : String(Math.round(v));
}

function StatBox(props) {
  return (
    <div style={{ flex: 1, minWidth: 92, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '8px 12px', textAlign: 'center' }}>
      <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: '#556677' }}>{props.label}</div>
      <div style={{ fontSize: 18, fontWeight: 800, color: props.color || '#e5e7eb', marginTop: 2 }}>{props.value}</div>
    </div>
  );
}

var FIELD_LBL = { fontSize: 12, color: '#8b98a9', marginBottom: 5 };
var FIELD_IN = { width: '100%', boxSizing: 'border-box', background: '#0d1524', border: '1px solid #26334a', borderRadius: 8, color: '#e5e7eb', fontSize: 14, padding: '9px 12px', fontFamily: 'inherit' };

function Field(props) {
  return (
    <div>
      <div style={FIELD_LBL}>{props.label}{props.hint ? <span style={{ color: '#ef4444', fontSize: 10 }}> {props.hint}</span> : null}</div>
      {props.options ? (
        <select value={props.value} onChange={function (e) { props.onChange(e.target.value); }} style={FIELD_IN}>
          {props.options.map(function (o) { return <option key={o[0]} value={o[0]}>{o[1]}</option>; })}
        </select>
      ) : (
        <input type={props.type || 'text'} value={props.value} onChange={function (e) { props.onChange(e.target.value); }} style={FIELD_IN} />
      )}
    </div>
  );
}

function WallBox(props) {
  var w = props.wall;
  var held = props.heldStrike != null && w && w.strike === props.heldStrike;
  return (
    <div style={{ flex: 1, minWidth: 150, background: '#0d1524', border: '1px solid ' + (held ? 'rgba(34,197,94,0.5)' : '#1f2937'), borderRadius: 10, padding: '10px 14px' }}>
      <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: props.color }}>{props.label}</div>
      {w ? (
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#e5e7eb', marginTop: 2 }}>
            {w.strike}
            {held ? <span style={{ fontSize: 9, fontWeight: 800, color: '#22c55e', marginLeft: 8 }}>HELD ✓</span> : null}
          </div>
          <div style={{ fontSize: 11, color: props.color, fontWeight: 800 }}>{fmtOI(w.oi)} OI</div>
        </div>
      ) : <div style={{ fontSize: 11, color: '#6b7a8d', padding: '8px 0' }}>--</div>}
    </div>
  );
}

var OIWalls3x = function () {
  var [state, setState] = useState(null);
  var [showCfg, setShowCfg] = useState(false);
  var [draft, setDraft] = useState({});
  var [err, setErr] = useState('');

  var fetchState = useCallback(function () {
    fetch(API + '/oiwalls3x/state').then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.error) { setState(d); setErr(''); } else setErr((d && d.error) || 'unavailable');
    }).catch(function () { setErr('backend unreachable'); });
  }, []);

  useEffect(function () {
    fetchState();
    var id = setInterval(fetchState, 1000);
    function wake() { if (!document.hidden) fetchState(); }
    document.addEventListener('visibilitychange', wake);
    return function () { clearInterval(id); document.removeEventListener('visibilitychange', wake); };
  }, [fetchState]);

  var cfg = (state && state.config) || {};
  var enabled = cfg.enabled !== false;

  function postCfg(payload, close) {
    fetch(API + '/oiwalls3x/config', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function () { if (close) { setShowCfg(false); } setTimeout(fetchState, 400); }).catch(function () {});
  }
  function openCfg() {
    setDraft({
      entry_time: cfg.entry_time || '09:17', exit_time: cfg.exit_time || '15:00',
      paper_lots: cfg.paper_lots != null ? cfg.paper_lots : 1,
      check_interval_sec: cfg.check_interval_sec != null ? cfg.check_interval_sec : 30,
      band: cfg.band != null ? cfg.band : 5,
      band_expiry: cfg.band_expiry != null ? cfg.band_expiry : 3,
      zone_mode: cfg.zone_mode || 'own_side',
      roll_threshold_pct: cfg.roll_threshold_pct != null ? cfg.roll_threshold_pct : 5,
      max_rolls_per_side: cfg.max_rolls_per_side != null ? cfg.max_rolls_per_side : 0,
      spread_haircut_pct: cfg.spread_haircut_pct != null ? cfg.spread_haircut_pct : 0.25,
      mtm_sl_per_lot: cfg.mtm_sl_per_lot || 0, target_per_lot: cfg.target_per_lot || 0,
      protect_per_lot: cfg.protect_per_lot || 0, protect_level_per_lot: cfg.protect_level_per_lot || 0,
      trail_step_per_lot: cfg.trail_step_per_lot || 0,
    });
    setShowCfg(true);
  }
  function saveCfg() {
    var p = {};
    Object.keys(draft).forEach(function (k) {
      var v = draft[k];
      p[k] = (k === 'entry_time' || k === 'exit_time' || k === 'zone_mode') ? v : Number(v);
    });
    postCfg(p, true);
  }
  function D(k) { return function (v) { var d = Object.assign({}, draft); d[k] = v; setDraft(d); }; }

  var walls = (state && state.walls) || {};
  var pos = state && state.position;
  var st = (state && state.stats) || {};
  var trades = (state && state.trades) || [];
  var events = (state && state.events) || [];
  var cardBase = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 12, padding: '12px 14px' };
  // ARRAYS, not single values — there are three legs per side now. Taking
  // [0] would have marked only the first as held and shown the other two
  // as unheld even though they are sold.
  var heldCE = pos ? pos.legs.filter(function (l) { return l.side === 'CE'; }).map(function (l) { return l.strike; }) : [];
  var heldPE = pos ? pos.legs.filter(function (l) { return l.side === 'PE'; }).map(function (l) { return l.strike; }) : [];

  return (
    <div style={{ padding: '18px 22px', color: '#e5e7eb', fontFamily: 'inherit', maxWidth: 1300 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 22, fontWeight: 800 }}>🧱 OI Walls 3x</span>
            <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#38bdf8', background: 'rgba(56,189,248,0.1)', border: '1px solid rgba(56,189,248,0.4)', borderRadius: 6, padding: '3px 8px' }}>SIGNALS ONLY — NO ORDERS</span>
            {state && state.is_expiry_day ? <span style={{ fontSize: 9, fontWeight: 800, color: '#fbbf24', background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.45)', borderRadius: 6, padding: '3px 8px' }}>EXPIRY · band ±{cfg.band_expiry || 3}</span> : null}
            {state && state.day_stopped ? <span style={{ fontSize: 9, fontWeight: 800, color: '#ef4444', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.45)', borderRadius: 6, padding: '3px 8px' }}>DAY STOPPED · {state.day_stopped}</span> : null}
          </div>
          <div style={{ fontSize: 10, color: '#6b7a8d', marginTop: 3 }}>
            NIFTY · {cfg.paper_lots || 1}L · Entry {cfg.entry_time || '09:17'} · sells the walls (max Total OI, ATM±{cfg.band || 5}) · rolls on &gt;{cfg.roll_threshold_pct || 5}% leadership · exit {cfg.exit_time || '15:00'}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: enabled ? '#22c55e' : '#6b7a8d' }}>
            {enabled ? '● ENABLED' : '○ DISABLED'}
          </span>
          <button onClick={function () { postCfg({ enabled: !enabled }); }}
            style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '7px 18px',
                     background: enabled ? 'rgba(239,68,68,0.12)' : 'rgba(34,197,94,0.12)',
                     color: enabled ? '#ef4444' : '#22c55e',
                     border: '1px solid ' + (enabled ? 'rgba(239,68,68,0.5)' : 'rgba(34,197,94,0.5)') }}>
            {enabled ? 'Disable' : 'Enable'}
          </button>
          <button onClick={openCfg}
            style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', background: 'transparent', color: '#8b98a9', border: '1px solid #1f2937', borderRadius: 8, padding: '7px 14px', fontFamily: 'inherit' }}>⚙</button>
        </div>
      </div>

      {err ? <div style={{ ...cardBase, borderColor: 'rgba(251,191,36,0.45)', color: '#fbbf24', fontSize: 11, marginBottom: 12 }}>OI Walls 3x: {err}</div> : null}

      <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1.1, minWidth: 330, ...cardBase }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677' }}>
              WALLS · ATM {walls.atm || '--'} · ±{walls.band || (state && state.is_expiry_day ? cfg.band_expiry : cfg.band) || '--'} · {(walls.zone || cfg.zone_mode) === 'any' ? 'ANY STRIKE' : 'OWN SIDE'}
            </span>
            <span style={{ fontSize: 10, color: '#6b7a8d' }}>{walls.time || '--'}</span>
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {/* Three per side. heldStrike marks the ones actually sold, so a
                wall that is in the top three but not yet held (mid-roll, or
                blocked by the churn threshold) is visibly different. */}
            <div style={{ flex: 1 }}>
              {(walls.ce_top || (walls.ce ? [walls.ce] : [])).map(function (w, i) {
                return <WallBox key={'ce'+i} label={'CE WALL ' + (i+1) + ' (resistance)'}
                         wall={w} color="#ef4444"
                         heldStrike={heldCE.indexOf(w.strike) > -1 ? w.strike : null} />;
              })}
            </div>
            <div style={{ flex: 1 }}>
              {(walls.pe_top || (walls.pe ? [walls.pe] : [])).map(function (w, i) {
                return <WallBox key={'pe'+i} label={'PE WALL ' + (i+1) + ' (support)'}
                         wall={w} color="#22c55e"
                         heldStrike={heldPE.indexOf(w.strike) > -1 ? w.strike : null} />;
              })}
            </div>
          </div>
        </div>

        <div style={{ flex: 1, minWidth: 300, ...cardBase }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677' }}>
              POSITION{pos ? ' · ' + pos.shape : ''}
            </span>
            {pos ? <span style={{ fontSize: 11, fontWeight: 800, color: (pos.unrealized || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(pos.unrealized)}{pos.peak_pl ? <span style={{ color: '#6b7a8d', fontWeight: 400 }}> · peak {fmtINR(pos.peak_pl)}/L</span> : null}</span> : null}
          </div>
          {pos ? (
            <div style={{ fontSize: 11, lineHeight: 1.9 }}>
              <div style={{ fontWeight: 800, color: '#38bdf8' }}>
                {pos.lots || 1}L · since {pos.opened} · credit {pos.credit}
                {pos.protect_armed ? <span style={{ fontSize: 9, color: '#fbbf24', marginLeft: 8 }}>PROTECT ARMED</span> : null}
              </div>
              {(pos.legs || []).map(function (l, i) {
                return <div key={i} style={{ color: '#8b98a9' }}>
                  SELL {l.strike} {l.side} @ {l.entry} → {l.ltp}
                  <span style={{ fontSize: 9, color: '#556677', marginLeft: 6 }}>OI@in {fmtOI(l.oi_at_entry)}</span>
                  <span style={{ float: 'right', fontWeight: 800, color: (l.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(l.pnl)}</span>
                </div>;
              })}
            </div>
          ) : (
            <div style={{ fontSize: 10, color: '#6b7a8d', padding: '14px 0', textAlign: 'center' }}>
              {state && state.day_stopped ? 'Day stopped (' + state.day_stopped + ') — flat until tomorrow. Reset paper to resume.'
                : state && state.entered_today ? 'Done for the day (one entry per day). Reset paper to re-arm.'
                : 'Flat. Sells both walls at ' + (cfg.entry_time || '09:17') + '.'}
            </div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <StatBox label="DAY P&L" value={fmtINR(st.day_pnl)} color={(st.day_pnl || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="REALIZED" value={fmtINR(st.realized)} color={(st.realized || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="UNREALIZED" value={fmtINR(st.unrealized)} color={(st.unrealized || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="ROLLS CE" value={st.rolls_ce != null ? st.rolls_ce : '--'} color="#ef4444" />
        <StatBox label="ROLLS PE" value={st.rolls_pe != null ? st.rolls_pe : '--'} color="#22c55e" />
      </div>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <div style={{ flex: 1.2, minWidth: 340, ...cardBase }}>
          <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 10 }}>TRADES &amp; ROLLS TODAY</div>
          {trades.length ? trades.map(function (t, i) {
            return (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, padding: '7px 0', borderBottom: '1px solid #131a2a', fontSize: 11, flexWrap: 'wrap' }}>
                <span style={{ fontWeight: 800, color: t.type === 'ROLL' ? '#fbbf24' : '#38bdf8' }}>{t.type === 'ROLL' ? 'ROLL ' + t.dir : t.dir}</span>
                <span style={{ color: '#8b98a9' }}>{t.closed}</span>
                <span style={{ fontSize: 9, fontWeight: 800, color: '#8b98a9' }}>{t.reason}</span>
                <span style={{ fontWeight: 800, color: (t.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(t.pnl)}</span>
              </div>
            );
          }) : <div style={{ fontSize: 10, color: '#6b7a8d', padding: '14px 0', textAlign: 'center' }}>No closed trades yet today.</div>}
        </div>
        <div style={{ flex: 1, minWidth: 300, ...cardBase }}>
          <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 10 }}>EVENTS</div>
          <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            {events.length ? events.slice().reverse().map(function (ev, i) {
              return <div key={i} style={{ fontSize: 10, color: '#8b98a9', padding: '3px 0', borderBottom: '1px solid #0d1524' }}>
                <span style={{ color: '#556677' }}>{ev.time}</span> {ev.text}
              </div>;
            }) : <div style={{ fontSize: 10, color: '#6b7a8d', textAlign: 'center', padding: '14px 0' }}>Quiet.</div>}
          </div>
        </div>
      </div>

      {showCfg ? (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(3,6,12,0.75)', zIndex: 60, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '40px 16px' }}
          onClick={function (e) { if (e.target === e.currentTarget) setShowCfg(false); }}>
          <div style={{ background: '#0b1220', border: '1px solid #26334a', borderRadius: 14, padding: '22px 26px', width: '100%', maxWidth: 560 }}>
            <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 18 }}>OI Walls 3x Settings</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="Entry Time" value={draft.entry_time} onChange={D('entry_time')} />
              <Field label="Exit Time" value={draft.exit_time} onChange={D('exit_time')} />
              <Field label="Lots" type="number" value={draft.paper_lots} onChange={D('paper_lots')} />
              <Field label="Check Interval (s)" type="number" value={draft.check_interval_sec} onChange={D('check_interval_sec')} />
            </div>
            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#556677', margin: '20px 0 10px' }}>WALL SELECTION</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="Candidate Band" value={draft.band} onChange={D('band')}
                options={[[5, 'ATM ±5 strikes'], [10, 'ATM ±10 strikes']]} />
              <Field label="Expiry-Day Band" value={draft.band_expiry} onChange={D('band_expiry')}
                options={[[2, 'ATM ±2 strikes'], [3, 'ATM ±3 strikes'], [4, 'ATM ±4 strikes'], [5, 'ATM ±5 strikes']]} />
              <Field label="Candidate Zone" value={draft.zone_mode} onChange={D('zone_mode')}
                options={[['own_side', 'Own side (CE ≥ ATM · PE ≤ ATM)'], ['any', 'Any strike in band']]} />
              <Field label="Roll Threshold %" type="number" value={draft.roll_threshold_pct} onChange={D('roll_threshold_pct')} />
              <Field label="Max Rolls / side" hint="(0=unlimited)" type="number" value={draft.max_rolls_per_side} onChange={D('max_rolls_per_side')} />
              <Field label="Fill Haircut % / leg" type="number" value={draft.spread_haircut_pct} onChange={D('spread_haircut_pct')} />
            </div>
            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#556677', margin: '20px 0 10px' }}>PROFIT MANAGEMENT <span style={{ color: '#6b7a8d', fontWeight: 400 }}>(₹ per lot · any trigger exits &amp; stops the day)</span></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="MTM SL ₹/lot" hint="(0=off)" type="number" value={draft.mtm_sl_per_lot} onChange={D('mtm_sl_per_lot')} />
              <Field label="Target ₹/lot" hint="(0=off)" type="number" value={draft.target_per_lot} onChange={D('target_per_lot')} />
              <Field label="Protect ₹/lot" hint="(0=off)" type="number" value={draft.protect_per_lot} onChange={D('protect_per_lot')} />
              <Field label="Protect Level ₹/lot" type="number" value={draft.protect_level_per_lot} onChange={D('protect_level_per_lot')} />
              <Field label="Trail Step ₹/lot" hint="(0=off)" type="number" value={draft.trail_step_per_lot} onChange={D('trail_step_per_lot')} />
            </div>
            <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
              <button onClick={function () { setShowCfg(false); }}
                style={{ flex: 1, fontSize: 13, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', background: '#0d1524', color: '#c4cfd8', border: '1px solid #26334a', borderRadius: 10, padding: '12px 0' }}>Cancel</button>
              <button onClick={saveCfg}
                style={{ flex: 1, fontSize: 13, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', background: 'rgba(34,197,94,0.15)', color: '#22c55e', border: '1px solid rgba(34,197,94,0.5)', borderRadius: 10, padding: '12px 0' }}>Save</button>
            </div>
            <div style={{ marginTop: 14, textAlign: 'center' }}>
              <button onClick={function () { fetch(API + '/oiwalls3x/reset-paper', { method: 'POST' }).then(function () { setShowCfg(false); setTimeout(fetchState, 400); }); }}
                style={{ fontSize: 10, fontWeight: 800, cursor: 'pointer', background: 'transparent', color: '#ef4444', border: '1px solid rgba(239,68,68,0.4)', borderRadius: 8, padding: '6px 16px', fontFamily: 'inherit' }}>Reset paper · clears day-stop &amp; re-arms entry</button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default OIWalls3x;
